<mat-expansion-panel [expanded]="expanded" [disabled]="disabled" class="select-expansion-panel" (opened)="panelOpenState = true" (closed)="panelOpenState = false" [hideToggle]="true">
  <mat-expansion-panel-header class="select-expansion-panel-header" #matExpansionPanel>
    <!-- <div class="custom-badge" *ngIf="showBadge()">
      <mat-icon class="badge-icon">circle</mat-icon>
    </div>-->
    <!-- Header content goes here -->
    <mat-panel-title class="select-expansion-panel-header-title">
      <mat-icon
        class="select-expansion-panel-header-title-icon material-symbols-outlined"
        *ngIf="showIcon && !icon.includes('svg')"
      >
        {{icon}}
      </mat-icon>
      <img
        class="select-expansion-panel-header-title-icon img-icon"
        *ngIf="showIcon && icon.includes('svg')"
        [src]="'../../../../../assets/images/'+icon"
      />
      <div class="select-expansion-panel-header-title-label" >
        {{ label }}
      </div>
      <img *ngIf="showInfo" class="select-expansion-panel-header-title-info-icon" (click)="onInfoClick()" src="../../../../assets/images/icon-info-outline.svg">
    </mat-panel-title>
    <mat-panel-description class="select-expansion-panel-header-arrow">
      <mat-icon class="select-expansion-panel-header-arrow-icon" *ngIf="!panelOpenState && !disabled">arrow_drop_down</mat-icon>
      <mat-icon class="select-expansion-panel-header-arrow-icon" *ngIf="panelOpenState && !disabled">arrow_drop_up</mat-icon>
      <img *ngIf="disabled"  [matTooltip]="disabledTooltip"  matTooltipPosition="left"  class="select-expansion-panel-header-title-info-icon" (click)="onInfoClick()" src="../../../../assets/images/icon-info-outline.svg">
    </mat-panel-description>
  </mat-expansion-panel-header>

  <!-- Panel content goes here -->
  <div class="select-expansion-panel-selection-list">
    <div
      class="select-expansion-panel-selection-list-option"
      [ngClass]="{ 'select': type === 'Select'}"
      *ngFor="let option of _options"
      (click)="onOptionSelect(option, $event)"
      [ngClass]="[selectedClass(option), typeClass()]"
    >
      <div *ngIf="type === 'CheckBox' || type === 'Radio'" class="select-expansion-panel-selection-list-option-selector">
        <mat-checkbox
          *ngIf="type === 'CheckBox'"
          class="select-expansion-panel-selection-list-option-checkbox"
          (change)="onOptionSelect(option, $event)"
          (click)="$event.stopPropagation()"
          [checked]="isOptionSelected(option)"
        ></mat-checkbox>
        <mat-radio-group [value]="isOptionSelected(option) ? option.id :  undefined">
          <mat-radio-button
            (change)="onOptionSelect(option)"
            (click)="$event.stopPropagation()"
            [value]="option.id"
            *ngIf="type === 'Radio'"
          > </mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="select-expansion-panel-selection-list-option-text">
        {{ option.name }} <span *ngIf="option.details" class="details">({{option.details}})</span>
      </div>
      <div class="select-expansion-panel-selection-list-option-selected-icon">
        <img *ngIf="isOptionSelected(option) && type === 'Select'"  src="../../../../assets/images/icon-check-outlined.svg">
      </div>
    </div>

  </div>

</mat-expansion-panel>
